import { Tag } from "bbcode-to-react";
import * as React from "react";
class StyleTag extends Tag {
    toHTML() {
        const style = this.params.style;
        return [`<span class="${style}">`, this.getContent(), "</span>"];
    }
    toReact() {
        const style = this.params.style;
        return React.createElement("span", { className: style }, this.getComponents());
    }
}
export default StyleTag;
